module.exports = __webpack_public_path__ + "static/goldstein-2a8bb42843250336b73f3efb97002281.png";